import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import './Contact.css';

class Contact extends Component {
  render() {
    return (
      <div id="contact">
        <div className="container">
          <h2>Thank you for contacting us!</h2>
          <p>We appreciate your interest in Zygous Labs. We'll be reaching back out to you shortly!</p><br/><br/>
          
        </div>
      </div>

    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/ThankYou.js